import {
  RESIZE_SCREEN,
  SET_ORIENTATION
} from 'shared/actions/types';

export const resizeScreen = (width, height) => dispatch => {
  dispatch({
    type: RESIZE_SCREEN,
    payload: { width, height }
  });
}

export const setOrientation = orientation => dispatch => {
  dispatch({
    type: SET_ORIENTATION,
    payload: orientation
  });
}
